<script setup lang="ts">
/**
 * PrintingOverlay — full-screen modal overlay shown while a print job is
 * being submitted.  Teleports to `<body>` so it sits above PrimeVue dialogs
 * (which use z-index ~1100).
 *
 * Usage:
 *   <PrintingOverlay :visible="isPrinting" />
 */
defineProps<{
  /** Controls overlay visibility */
  visible: boolean;
}>();
</script>

<template>
  <Teleport to="body">
    <div
      v-if="visible"
      role="dialog"
      aria-live="assertive"
      :aria-label="$t('printJob.submitting')"
      class="fixed inset-0 flex items-center justify-center bg-black/40"
      style="z-index: 9999"
    >
      <div class="flex flex-col items-center gap-3 rounded-2xl bg-white px-10 py-8 shadow-xl">
        <div
          class="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-primary-600"
          aria-hidden="true"
        />
        <p class="text-sm font-medium text-gray-700">
          {{ $t('printJob.submitting') }}
        </p>
      </div>
    </div>
  </Teleport>
</template>
